
const initialState = {
  cereal: null,
  cerealVariedad: null,
  etiqueta: null
}

export function reducerFiltroReporteParaEmbarque (state = initialState, { type, ...other }) {
  switch (type) {
    case 'UPDATE_FILTROS_PARA_EMBARQUE':
      return { ...state, ...other }
    default:
      return state
  }
}
